import { render, staticRenderFns } from "./BaseLogItem.vue?vue&type=template&id=36a058a6&scoped=true"
import script from "./BaseLogItem.vue?vue&type=script&lang=js"
export * from "./BaseLogItem.vue?vue&type=script&lang=js"
import style0 from "./BaseLogItem.vue?vue&type=style&index=0&id=36a058a6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a058a6",
  null
  
)

export default component.exports